import "./styles.scss";

export type Tab = "franquia" | "saldo";

export interface ITabsProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
}

const Tabs = ({ activeTab, onTabChange }: ITabsProps) => (
  <section className="margin-bottom-20 contract-details-tabs-wrap">
    <div className="contract-details-tabs">
      <button
        type="button"
        onClick={() => onTabChange("franquia")}
        className={`contract-details-tabs__btn ${activeTab === "franquia" ? "contract-details-tabs__btn--active" : ""}`}
      >
        Franquia
      </button>
      <button
        type="button"
        onClick={() => onTabChange("saldo")}
        className={`contract-details-tabs__btn ${activeTab === "saldo" ? "contract-details-tabs__btn--active" : ""}`}
      >
        Saldo
      </button>
    </div>
  </section>
);

export default Tabs;
